import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  // Lock body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Case Studies',
    path: '/case-studies'
  }, {
    name: 'Contact',
    path: '/contact'
  }, {
    name: 'Careers',
    path: '/careers'
  }];
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-engage-gray1/95 backdrop-blur-md border-b border-engage-gray2 py-4' : 'bg-transparent py-6'}`} data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="flex items-center" data-id="element-62">
          {/* Logo - Left Aligned */}
          <Link to="/" className="flex items-center z-50" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/rubaJbsbfYXRnY6rEG65oJ/Logo_Engage_Media_white.png" alt="Engage Media" className="h-16 w-auto" data-id="element-64" />
          </Link>

          {/* Desktop Nav - Center Aligned */}
          <nav className="hidden lg:flex items-center space-x-8 flex-1 justify-center" data-id="element-65">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-base font-medium transition-colors hover:text-engage-yellow ${location.pathname === link.path ? 'text-engage-yellow' : 'text-engage-gray5'}`} data-id="element-66">
                {link.name}
              </Link>)}
          </nav>

          {/* Button - Right Aligned */}
          <div className="hidden lg:block" data-id="element-67">
            <Button to="/contact" variant="primary" data-id="element-68">
              Book a Call With Us
            </Button>
          </div>

          {/* Mobile/Tablet Menu Button */}
          <button className="lg:hidden text-engage-white z-50 p-2 ml-auto relative touch-manipulation" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-69">
            {isOpen ? <X size={24} data-id="element-70" /> : <Menu size={24} data-id="element-71" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      <div className={`fixed inset-0 bg-engage-black z-40 flex flex-col justify-center items-center space-y-8 transition-transform duration-300 ease-in-out lg:hidden min-h-screen h-screen touch-none ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} onClick={e => {
      if (e.target === e.currentTarget) {
        setIsOpen(false);
      }
    }} data-id="element-72">
        {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-2xl font-bold transition-colors ${location.pathname === link.path ? 'text-engage-yellow' : 'text-engage-white'}`} data-id="element-73">
            {link.name}
          </Link>)}
        <div className="pt-8" data-id="element-74">
          <Button to="/contact" variant="primary" data-id="element-75">
            Book a Call With Us
          </Button>
        </div>
      </div>
    </header>;
}